<script>

import employeesDialog from '@/components/workflow/dialog/employeesDialog.vue'

export default {
  name: 'RobotSend',
  components: { employeesDialog },
  data() {
    return {
      formData: {
        msg_key: '',
        msg_param: {},
        userids: ''//钉钉userid数组
      },
      visible: false,
      checkedList: [],
      msgParamsStruct: [
        { field: 'content', data_type: 'textarea' }
      ],
      msgTypOptions: [
        {
          title: '文本类型',
          value: 'sampleText',
          tpl: `{"content": "xxxx"}`,
          args: [{ field: 'content', data_type: 'textarea', label: '消息内容' }]
        },
        {
          title: 'Markdown类型', value: 'sampleMarkdown',
          tpl: `{
    "title": "xxxx",
    "text": "xxxx"
  }`, args: [
            { field: 'title', data_type: 'text', label: '标题' },
            { field: 'text', data_type: 'textarea', label: '消息内容' }
          ]
        },
        {
          title: '图片类型', value: 'sampleImageMsg', tpl: `{"photoURL": "xxxx"}`, args: [
            { field: 'photoURL', data_type: 'text', label: '图片链接' }
          ]
        },
        {
          title: '链接类型', value: 'sampleLink',
          tpl: `{

     "text": "消息内容测试",
     "title": "sampleLink消息测试",
     "picUrl": "@lADOADmaWMzazQKA",
     "messageUrl": "http://dingtalk.com"

}`, args: [
            { field: 'title', data_type: 'text', label: '标题' },
            { field: 'text', data_type: 'text', label: '消息内容' },
            { field: 'picUrl', data_type: 'text', label: '图片链接' },
            { field: 'messageUrl', data_type: 'text', label: '消息链接' }
          ]
        },
        {
          title: 'ActionCard类型', value: 'sampleActionCard', tpl: `{
     "title": "测试标题",
     "text": "内容测试",
     "singleTitle": "查看详情",
     "singleURL": "https://open.dingtalk.com"
}`, args: [
            { field: 'title', data_type: 'text', label: '标题' },
            { field: 'text', data_type: 'text', label: '消息内容' },
            { field: 'singleTitle', data_type: 'text', label: '消息链接标题', example: '查看详情' },
            { field: 'singleURL', data_type: 'text', label: '消息链接', example: 'https://open.dingtalk.com' }
          ]
        },
        {
          title: 'ActionCard类型2', value: 'sampleActionCard2',
          args: [
            { field: 'title', data_type: 'text', label: '标题' },
            { field: 'text', data_type: 'text', label: '消息内容' },
            { field: 'actionTitle1', data_type: 'text', label: '标题1', example: '查看详情' },
            { field: 'actionURL1', data_type: 'text', label: '跳转链接1', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle2', data_type: 'text', label: '标题2', example: '已阅' },
            { field: 'actionURL2', data_type: 'text', label: '跳转链接2', example: 'https://open.dingtalk.com' }
          ],
          tpl: `{
     "title": "消息标题测试",
     "text": "消息正文测试",
     "actionTitle1": "一个按钮",
     "actionURL1": "https://www.taobao.com",
     "actionTitle2": "两个按钮",
     "actionURL2": "https://www.tmall.com"
}`
        },
        {
          title: 'ActionCard类型3', value: 'sampleActionCard3',
          args: [
            { field: 'title', data_type: 'text', label: '标题' },
            { field: 'text', data_type: 'text', label: '消息内容' },
            { field: 'actionTitle1', data_type: 'text', label: '标题1', example: '按钮1' },
            { field: 'actionURL1', data_type: 'text', label: '跳转链接1', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle2', data_type: 'text', label: '标题2', example: '按钮2' },
            { field: 'actionURL2', data_type: 'text', label: '跳转链接2', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle3', data_type: 'text', label: '标题3', example: '按钮3' },
            { field: 'actionURL3', data_type: 'text', label: '跳转链接3', example: 'https://open.dingtalk.com' }
          ],
          tpl: `{
     "title": "消息标题测试",
     "text": "消息内容测试",
     "actionTitle1": "第一个按钮的文本",
     "actionURL1": "第一个按钮触发的url",
     "actionTitle2": "第二个按钮的文本",
     "actionURL2": "第二个按钮触发的url",
     "actionTitle3": "第三个按钮的文本",
     "actionURL3": "第三个按钮触发的url"
}`
        },
        {
          title: 'ActionCard类型4', value: 'sampleActionCard4',   args: [
            { field: 'title', data_type: 'text', label: '标题' },
            { field: 'text', data_type: 'text', label: '消息内容' },
            { field: 'actionTitle1', data_type: 'text', label: '标题1', example: '按钮1' },
            { field: 'actionURL1', data_type: 'text', label: '跳转链接1', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle2', data_type: 'text', label: '标题2', example: '按钮2' },
            { field: 'actionURL2', data_type: 'text', label: '跳转链接2', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle3', data_type: 'text', label: '标题3', example: '按钮3' },
            { field: 'actionURL3', data_type: 'text', label: '跳转链接3', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle4', data_type: 'text', label: '标题4', example: '按钮4' },
            { field: 'actionURL4', data_type: 'text', label: '跳转链接4', example: 'https://open.dingtalk.com' }
          ], tpl: `{
  "title":"消息标题测试",
"text":"消息内容测试",
"actionTitle1":"第一个按钮的文本",
"actionURL1":"第一个按钮触发的url",
"actionTitle2":"第二个按钮的文本",
"actionURL2":"第二个按钮触发的url",
"actionTitle3":"第三个按钮的文本",
"actionURL3":"第三个按钮触发的url",
"actionTitle4":"第四个按钮的文本",
"actionURL4":"第四个按钮触发的url"
}`
        },
        {
          title: 'ActionCard类型5', value: 'sampleActionCard5',args: [
            { field: 'title', data_type: 'text', label: '标题' },
            { field: 'text', data_type: 'text', label: '消息内容' },
            { field: 'actionTitle1', data_type: 'text', label: '标题1', example: '按钮1' },
            { field: 'actionURL1', data_type: 'text', label: '跳转链接1', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle2', data_type: 'text', label: '标题2', example: '按钮2' },
            { field: 'actionURL2', data_type: 'text', label: '跳转链接2', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle3', data_type: 'text', label: '标题3', example: '按钮3' },
            { field: 'actionURL3', data_type: 'text', label: '跳转链接3', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle4', data_type: 'text', label: '消标题4', example: '按钮4' },
            { field: 'actionURL4', data_type: 'text', label: '跳转链接4', example: 'https://open.dingtalk.com' },
            { field: 'actionTitle5', data_type: 'text', label: '标题5', example: '按钮5' },
            { field: 'actionURL5', data_type: 'text', label: '跳转链接5', example: 'https://open.dingtalk.com' }
          ],  tpl: `{
  "title":"消息标题测试",
"text":"消息内容测试",
"actionTitle1":"第一个按钮的文本",
"actionURL1":"第一个按钮触发的url",
"actionTitle2":"第二个按钮的文本",
"actionURL2":"第二个按钮触发的url",
"actionTitle3":"第三个按钮的文本",
"actionURL3":"第三个按钮触发的url",
"actionTitle4":"第四个按钮的文本",
"actionURL4":"第四个按钮触发的url",
"actionTitle5":"第五个按钮的文本",
"actionURL5":"第五个按钮触发的url"
}`
        },
        {
          title: '语音类型', value: 'sampleAudio', tpl: `{
    "mediaId": "@IR_P********nFkfhsisbf4A",
    "duration":"xxxxx"
 }`
        },
        {
          title: '文件类型', value: 'sampleFile', tpl: `{
   "mediaId":"@lAz*********shRs5m2pRL",
   "fileName":"表格.xlsx",
   "fileType":"xlsx",
}`
        },
        {
          title: '视频类型', value: 'sampleVideo', tpl: `{
    "duration":"999",
    "videoMediaId":"$iQEL**********AXNSs6QPPAAABhKN2L3EEzTcTB84BFM7iCAAJomlt",
    "videoType":"mp4",
    "picMediaId":"$igE**********tAFzQUABtoAIYQBpAtR3SICqrQ7ZX0nEJzAKxUDzwAAAYSjdi2cBM02vwcACAAJomltCgQ"
}`
        }
      ]
    }
  },
  methods: {
    changeRecUser(user) {
      this.formData.userids = [user.userid]
      this.formData.names = [user.name]
      this.formData.msg_key = this.msgTypOptions[2].value
    },
    handleChangeOption() {
      const option = this.msgTypOptions.find(value => value.value === this.formData.msg_key)
      this.msgParamsStruct = option.args || []
    },
    sendNotifySingle() {
      this.$confirm(`给这『${this.formData.names}』个用户发送消息`, '消息通知', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.sendNotify([row])

        if (this.formData.userids.length > 0 && this.formData.msg_key)
          this.$api.sendMessage(this.formData)
        else {
          this.$notify.warning('用户和消息类型必须！！！')
        }

      })
    },
    choiceMember() {
      this.visible = true
    },
    handleChangeMembers(data) {
      this.checkedList = data
      this.formData.userids = data.map((member) => {
        if (member.type === 1)
          return member.targetId
      })
      this.formData.names = data.map((member) => {
        if (member.type === 1)
          return member.name
      })
      this.visible = false
      // if (data[0] && data[0].type === 1) {
      //   // this.nodeUserList = data
      //   this.formData.userid = data[0]['targetId']
      //   this.formData.name = data[0]['name']
      //   this.visible = false
      // } else {
      //   this.$notify.warning('请选择成员')
      // }

    }
  }
}
</script>

<template>
  <div>
    <div class='theme-border default-padding'>
      <el-form :model='formData' label-width='100px' size='small'>
        <el-form-item label='消息类型'>
          <el-select v-model='formData.msg_key' @change='handleChangeOption'>
            <el-option v-for='(msgTypOption,index) in msgTypOptions'
                       :value='msgTypOption.value'
                       :label='msgTypOption.title'
                       :key='msgTypOption.value'>
              <span>{{index+1}}、{{msgTypOption.title}} </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter='10' v-if='msgParamsStruct'>
          <el-col :span='24' v-for='(struct) in msgParamsStruct' :key='`msg_param_${struct.field}`'>
            <el-form-item :label='struct.label'>
              <el-input :type='struct.data_type' v-model='formData.msg_param[struct.field]'
                        :placeholder='`数据类型:${struct.data_type}`'></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item label='接收人'>
          <el-input v-model='formData.names' readonly placeholder='接收人钉钉ID'>
            {{ formData.names && formData.names.length > 0 ? formData.names.join('、') : '' }}
            <el-button slot='append' @click='choiceMember'>选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item style='text-align: center'>
          <el-button round size='medium' type='primary' icon='el-icon-s-promotion' @click='sendNotifySingle(formData)'>
            发送通知
          </el-button>
          <el-link style='float: right'
                   type='primary'
                   title='消息类型'
                   icon='el-icon-info'
                   target='_blank'
                   href='https://open.dingtalk.com/document/dingstart/types-of-messages-sent-by-robots?spm=ding_open_doc.document.0.0.68114a97MiEYFI'>

          </el-link>
        </el-form-item>
      </el-form>
    </div>

    <employees-dialog
      :isDepartment='true'
      :visible.sync='visible'
      :data.sync='checkedList'
      @change='handleChangeMembers'
    />
  </div>

</template>

<style scoped>

</style>
